import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'uui-grid-v2',
  styleUrl: 'uui-grid.css',
  shadow: true
})
export class UuiGrid {
  @Prop() direction: 'column' | 'row' = 'row';
  @Prop() alignItems: 'start' | 'center' | 'end' | 'stretch' = 'stretch';
  @Prop() justifyContent:
    | 'start'
    | 'center'
    | 'end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly' = 'start';

  render() {
    const alignItemsMap = {
      start: 'flex-start',
      center: 'center',
      end: 'flex-end',
      stretch: 'stretch'
    };

    const justifyContentMap = {
      start: 'flex-start',
      center: 'center',
      end: 'flex-end',
      'space-between': 'space-between',
      'space-around': 'space-around',
      'space-evenly': 'space-evenly'
    };

    const containerStyle = {
      alignItems: alignItemsMap[this.alignItems],
      justifyContent: justifyContentMap[this.justifyContent]
    };

    return (
      <Host>
        <div
          class={{ 'uui-grid': true, [this.direction]: true }}
          style={containerStyle}
        >
          <slot />
        </div>
      </Host>
    );
  }
}
